import { Point, Scale } from "../.././MyHelpers";
import { JackpotDisplayType, Settings } from "../../Settings";
import { FreegameBonus, FreegameBonusParams } from "./FreegameBonus";

export class FreegameBonus_2Screen extends FreegameBonus
{
	protected override plusOneTarget: Point = new Point(Scale.Y(260), Scale.Y(-225));
	public constructor(gameName: string, params: FreegameBonusParams ) 
	{
		super(gameName,params);	
		//Create some override for change the plus one postion 
		//works for 2 screens and for Classic Games only
		if( Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay){
			this.plusOneTarget.x = Scale.X(500);
		}	
	}	
}


export class FreeGameBonusFactory_2Screen implements IFreegameBonusFactory_2Screen
{
	public CreateFreegameBonus_2Screens(gameName: string, params: FreegameBonusParams): FreegameBonus
	{
		return new FreegameBonus_2Screen(gameName, params);
	}
}
export interface IFreegameBonusFactory_2Screen {
	CreateFreegameBonus_2Screens(gameName: string, params: FreegameBonusParams): FreegameBonus;
}
